module.exports = __webpack_public_path__ + "static/media/Wilba_Portrait.4adccc32.png";